import { createAction } from '@reduxjs/toolkit';
import { IDefaultSorting } from '../../interfaces/Dashboard';
import { ChildActions } from '../../store/typings';

export const DASHBOARD_SUMMARY_API_CONSTANTS = {
  GET_DASHBOARD_ACTIONS: '/api/V2/Actions/dashboard',
  GET_VIEWS: 'api/getViews',
  GET_VIEWS_WITH_FOLDERS: 'api/getViewsWithFolder',
  GET_ACTIONS_COUNT: '/api/V2/Actions/actionCount',
  SET_ACTIONS_COUNT: 'view/setActionsCount',
  WEB_API_URL: import.meta.env.VITE_WEBAPIURL || 'https://localhost:44381',
  GET_RELATED_WORK_ITEMS: '/api/Actions/getRelatedWorkItems',
};

const DASHBOARD_APP_INSIGHT_NAME = 'UAT-Dashboard-';

export const DASHBOARD_SUMMARY_APP_INSIGHTS = {
  CAROUSEL_NEXT_PAGE_CLICK: DASHBOARD_APP_INSIGHT_NAME + 'CarouselNextPageClick',
  DASHBOARD_GRID_SORT: DASHBOARD_APP_INSIGHT_NAME + 'DashboardGridSort',
  VIEW_CHANGE: DASHBOARD_APP_INSIGHT_NAME + 'ViewChange',
  FILTER_CHANGE: DASHBOARD_APP_INSIGHT_NAME + 'FilterChange',
};

export const DASHBOARD_SUMMARY_CONSTANTS = {
  JWT_TOKEN_FOR_API: 'jwtTokenForApi',
  JWT_TOKEN_FOR_CORE_API: 'jwtTokenForCoreApi',
  JWT_TOKEN_FOR_GRAPH: 'jwtTokenForGraph',
};

export const DASHBOARD_SYSTEM_FOLDERS = {
  AssignedToMe: 'assigned to me all states',
  RequestedByMe: 'requested by me',
  FollowedByMe: 'followed by me',
  AllActions: 'all',
};

export class dashboardConstants {
  public static ActionCount = {
    Actions: 'Items',
    NoActions: 'No Actions',
    actionCountToShow: '20000+',
    MaxADOActionsCountFromAPI: 19995,
  };
  public static pagination = {
    ItemsPerPage: {
      Default: 50,
    },
  };
  public static defaultSorting: IDefaultSorting = {
    column: 'System.ChangedDate',
    sortOrder: 'DESC',
  };
}

export const DASHBOARD_SUMMARY_ACTIONS = {
  SET_CHILD_ACTION_ITEMS: 'setChildActionItems',
  REMOVE_CHILD_ACTION_ITEMS: 'removeChildActionItems',
};

export const setChildActionItems = createAction(
  DASHBOARD_SUMMARY_ACTIONS.SET_CHILD_ACTION_ITEMS,
  function prepare(childActionItems: ChildActions) {
    return {
      payload: childActionItems,
    };
  }
);

export const removeChildActionItems = createAction(
  DASHBOARD_SUMMARY_ACTIONS.REMOVE_CHILD_ACTION_ITEMS,
  function prepare(childActionItems: ChildActions) {
    return {
      payload: childActionItems,
    };
  }
);
